// extracted by mini-css-extract-plugin
export var content = "_4z-3";
export var list = "_4z-4";
export var settingsContent = "_4z-7";
export var settingsPanel = "_4z-8";
export var state = "_4z-6";
export var triggerBadge = "_4z-2";
export var triggerButton = "_4z-1";
export var triggerShell = "_4z-0";
export var unreadDot = "_4z-5";